export default __webpack_public_path__ + "img/9781691a04aa506a3f6bdd61de76c36b.svg";